import { httpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '@/api/api-routes';

export enum FavoriteListType {
  FAVORITE = 'FAVORITE',
  BANNED = 'BANNED',
}

export type FavoriteDriverRequest = {
  supplier_id: string;
  list: FavoriteListType;
  token: string;
};

export const toggleFavoriteDriverFn = async (params: FavoriteDriverRequest) => {
  const response = await httpClient.get<NonNullable<unknown>>(
    apiRoutes.user.addFavoriteDriver,
    { params }
  );
  return response.data;
};
